import PressDetail from "./PressDetailContainer";

export default PressDetail;
